export default "__VITE_ASSET__Ctt3JoSp__"